import { render } from "./Señalado.vue?vue&type=template&id=ad903686"
import script from "./Señalado.vue?vue&type=script&lang=js"
export * from "./Señalado.vue?vue&type=script&lang=js"

import "./Señalado.vue?vue&type=style&index=0&id=ad903686&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__